import { Routes, Route, Navigate } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import HomePage from "./pages/HomePage";
import GettingStartedPage from "./pages/GettingStartedPage";
import HandPositionPage from "./pages/HandPositionPage";
import ModesPage from "./pages/ModesPage";
import SessionPage from "./pages/SessionPage";
import RoutinePage from "./pages/RoutinePage";
import HelpPage from "./pages/HelpPage";
import HelpArticlePage from "./pages/HelpArticlePage";
import SafetyPage from "./pages/SafetyPage";
import PrivacyPage from "./pages/PrivacyPage";

export default function App() {
  return (
    <div className="app-frame">
      <ErrorBoundary>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/getting-started" element={<GettingStartedPage />} />
        <Route path="/hand-position" element={<HandPositionPage />} />
        <Route path="/modes" element={<ModesPage />} />
        <Route path="/session" element={<SessionPage />} />
        <Route path="/routine" element={<RoutinePage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/help/:article" element={<HelpArticlePage />} />
        <Route path="/safety" element={<SafetyPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </ErrorBoundary>
    </div>
  );
}
